import React from 'react'
import { Route, Navigate } from 'react-router-dom'

import { useHasSitesOnProduction, useUser } from 'store'
import Home from './Home'

const Layout = () => {
  const [user] = useUser()
  const hasSitesOnProduction = useHasSitesOnProduction()

  if (!hasSitesOnProduction) {
    if (user.roles.project) {
      return <Navigate to={'/projects'} />
    } else {
      return <Navigate to={'/profile'} />
    }
  }

  return <Home />
}
export const routes = () => [
  <Route
    path={'/dashboard'}
    key="dashboard"
    element={
      <Layout />
    }
  />
]

export default routes
